import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Zone from "@frog/source/models/Zone.js"
import Dev from "@frog/source/models/dev/Dev.js"

import UnitSprite from "@frog/source/views/components/UnitSprite.jsx"
import UnitTemplateSprite from "@frog/source/views/components/UnitTemplateSprite.jsx"
import UnitHealthBar from "@frog/source/views/components/UnitHealthBar.jsx"
import UnitExperienceBar from "@frog/source/views/components/UnitExperienceBar.jsx"

import DiceCube from "@frog/source/data/games/dice/views/DiceCube.jsx"
import ItemBreakdown from "@frog/source/data/games/dice/views/ItemBreakdown.jsx"

import "@frog/source/views/components/Unit.less"

export default class Unit {
    render() {
        if((this.props.unit.type == "spot")
        && this.props.unit.properties?.includes("visible") != true
        && Dev.inProtoMode == false) {
            return
        }
        return [
            <div class="Unit" style={this.style} key={this.props.unit.key} isInBounds={this.isInBounds} affiliation={this.props.unit.affiliation} phase={this.props.stage.player?.phase}
                isHovered={this.isHovered} isSelected={false && this.isSelected} isLockedIn={this.props.unit.isLockedIn}>
                <UnitSprite unit={this.props.unit} isGrayscaled={this.isGrayscaled} index={this.props.index}/>
                <UnitHealthBar stage={this.props.stage} unit={this.props.unit} omegaunit={this.props.omegaunit} maxsegments={20}/>
                {this.props.unit.affiliation == this.props.stage.player?.affiliation && <UnitExperienceBar stage={this.props.stage} unit={this.props.unit}/>}
                {App.game.configuration.alwaysRenderUnitLevel && <div class="UnitLevel">Lv.{this.props.unit.level}</div>}
                <div class="Selection" isHovered={this.isHovered} isSelected={this.isSelected}/>
                <div class="PredictiveDamage">{this.predictiveDamage}</div>
                <div class="ReadyLabel">Locked!</div>
                <div class="ReadyingLabel">Lock?</div>
                <div class="DiceSection">
                    <DiceCube stage={this.props.stage} unit={this.props.unit} item={this.props.unit.equippedItem}
                        animation={this.props.stage.player?.phase == "rolling" ? "roll" : undefined} key={this.props.unit.rollcount}/>
                </div>
                <div class="ClickableArea" onMouseDown={this.onMouseDown()} onMouseUp={this.onMouseUp()} onMouseOut={this.onMouseOut()} onMouseOver={this.onMouseOver()}/>
            </div>,
            <div class="UnitItem" isRightClicked={this.isRightClicked}
                 style={{"left": this.position.x + 0.5 + "em", "top": this.position.y + 1.1 + "em"}}>
                <ItemBreakdown item={this.props.unit.equippedItem} unit={this.props.unit} stage={this.props.stage}/>
            </div>
            // <div class="DiceBreakdown"}
            //     isRightClicked={this.isRightClicked}>
            //     <div class="Content">
            //         <div class="Title">{this.props.unit.equippedItem?.title}</div>
            //         <div class="Description">
            //             {this.props.unit.equippedItem?.description.split(", ").map((description) => [<span>{description}</span>, <br/>])}
            //         </div>
            //     </div>
            // </div>
        ]
        // <div class="UnitElement" element={this.props.unit.element} style={{
        //     "background-color": elements[this.props.unit.element]?.color
        // }}/>
    }
    get predictiveDamage() {
        var predictiveDamage = 0
        if(App.game.chapter.selection.hoveredAction != undefined) {
            App.game.chapter.selection.hoveredAction.steps.forEach((step) => {
                step.deltastages.forEach((deltastage) => {
                    if(deltastage?.type == "particle"
                    && deltastage?.text?.unitKey == this.props.unit.key
                    && (deltastage.text?.type == "damage" || deltastage.text?.type == "healing")) {
                        const text = Number.parseFloat(deltastage.text.string)
                        if(Number.isNaN(text) == false) {
                            predictiveDamage += text
                        }
                    }
                    // {
                    //     "key": key,
                    //     "type": "particle",
                    //     "mark": mark,
                    //     "text": {
                    //         "string": text,
                    //         "font": font || "numbers",
                    //     },
                    //     "color": color,
                    //     "position": Geometry.add(position, {"z": 0}),
                    // },
                    if(deltastage?.flourish != undefined
                    && deltastage.flourish.name == "TextFloat"
                    && deltastage.flourish.unitKey == this.props.unit.key) {
                        const number = Number.parseFloat(deltastage.flourish.text)
                        if(Number.isNaN(number) == false) {
                            predictiveDamage += number
                        }
                    }
                })
            })
        }
        if(predictiveDamage == 0.5) {
            predictiveDamage = "½"
        }
        if(predictiveDamage == -0.5) {
            predictiveDamage = "-½"
        }
        if(predictiveDamage == 0) {
            return ""
        }
        return predictiveDamage + "hp"
    }
    get style() {
        return {
            "left": this.position.x + "em",
            "top": this.position.y + "em",
            "z-index": (this.props.unit.truestack) ?? (1000 + (this.position.y * 100) + (this.props.unit?.stack || 0)), // + (this.position.x)
            // "z-index": 50 + (this.props.unit?.stack || 0), // DICE removed for stacking
            "opacity": this.props.unit.opacity, // for death
        }
    }
    get position() {
        // if(App.game.chapter.selection.position.x == this.props.unit.position.x
        // && App.game.chapter.selection.position.y == this.props.unit.position.y) {
        //     return this.props.unit.position
        // }
        // if(App.game.chapter.selection?.selectedUnitKey == this.props.unit.key
        // && App.game.chapter.selection?.hoveredAction?.omegastage != undefined) {
        //     return App.game.chapter.selection.hoveredAction.omegastage.units[this.props.unit.key].position
        // }
        return this.props.unit.position
    }
    get isGrayscaled() {
        if(Dev.inProtoMode == true) return false
        return this.isDone || this.isInBounds == false
    }
    get isDone() {
        // if(this.props.unit.affiliation == "bad") return false // DICE
        if(this.props.unit.energy == undefined) return false
        return this.props.unit.energy["move"] === false
            && this.props.unit.energy["invoke skill"] === false
    }
    get isInBounds() {
        if(Dev.inProtoMode == true) return true
        if(this.props.stage.flags["ShowAllTheGuysWithoutTransparency"] == true) return true // pirates
        if(this.props.stage.currentEncounterKey == undefined) return false
        if(this.props.stage.encounters[this.props.stage.currentEncounterKey] == undefined) return false
        return Zone.isInBounds(this.props.stage.encounters[this.props.stage.currentEncounterKey].zone, {
            "x": Math.round(this.position.x),
            "y": Math.round(this.position.y),
            "z": Math.round(this.position.z)
        })
    }
    get isHovered() {
        // if(Dev.inProtoMode == false) return false
        return this.props.unit.key == App.game.chapter?.selection?.hoveredUnitKey
            || this.props.unit.key == Dev.devSelection.listHoveredUnitKey
    }
    get isSelected() {
        if(Dev.inProtoMode == false) return false
        if(this.props.unit.key == App.game.chapter?.selection?.selectedUnitKey) return true
        if(App.game.chapter?.selection?.multiselectedUnitKeys.includes(this.props.unit.key)) return true
        return false
    }

    onMouseDown() {
        return (event) => {
            if(event.button != 2) return
            event.stopPropagation()
            window.hasRightClicked = true
            this.isRightClicked = true
        }
    }
    onMouseUp() {
        return (event) => {
            if(event.button != 2) return
            event.stopPropagation()
            window.hasRightClicked = true
            this.isRightClicked = false
        }
    }
    onMouseOut() {
        return (event) => {
            event.stopPropagation()
            window.hasRightClicked = true
            this.isRightClicked = false
        }
    }
    onMouseOver() {
        return (event) => {
            if(event.button != 2 && event.buttons != 2) return
            event.stopPropagation()
            window.hasRightClicked = true
            this.isRightClicked = true
        }
    }
}
